const gtmStartLogin = () => {
    const path = window.location.pathname
    dataLayer.push({
        event: 'login',
        step: 'start_button',
        source_page: path,
        _clear: true,
    })
}

export default gtmStartLogin
